// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Data$dUTCTime from "../Data.UTCTime/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCurrencies from "../Restaumatic.Currencies/index.js";
import * as Restaumatic$dGeocoding$dTypes$dDeliveryAddress from "../Restaumatic.Geocoding.Types.DeliveryAddress/index.js";
import * as Restaumatic$dOrders$dTypes$dCoupon from "../Restaumatic.Orders.Types.Coupon/index.js";
import * as Restaumatic$dOrders$dTypes$dFulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic$dOrders$dTypes$dOrderOrigin from "../Restaumatic.Orders.Types.OrderOrigin/index.js";
import * as Restaumatic$dOrders$dTypes$dOrderUUID from "../Restaumatic.Orders.Types.OrderUUID/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const ItemInfo = x => x;
const DiscountInfo = x => x;
const OrderInfo = x => x;
const newtypeOrderInfo_ = {Coercible0: () => {}};
const newtypeItemInfo_ = {Coercible0: () => {}};
const newtypeDiscountInfo_ = {Coercible0: () => {}};
const hasFieldOrderInfo = dictHasField => dictHasField;
const hasFieldItemInfo = dictHasField => dictHasField;
const hasFieldDiscountInfo = dictHasField => dictHasField;
const eqItemInfo = {
  eq: x => y => x.name === y.name && (() => {
    if (x.productId.tag === "Nothing") { return y.productId.tag === "Nothing"; }
    if (x.productId.tag === "Just") {
      if (y.productId.tag === "Just") { return x.productId._1 === y.productId._1; }
      return false;
    }
    return false;
  })() && x.promotion === y.promotion && x.quantity === y.quantity && (() => {
    if (x.rating.tag === "Nothing") { return y.rating.tag === "Nothing"; }
    if (x.rating.tag === "Just") {
      if (y.rating.tag === "Just") { return x.rating._1 === y.rating._1; }
      return false;
    }
    return false;
  })() && x.total === y.total && x.unitPrice === y.unitPrice
};
const eqDiscountInfo = {eq: x => y => x.name === y.name && x.value === y.value};
const eqOrderInfo = {
  eq: x => y => Data$dEq.eqArrayImpl(Restaumatic$dOrders$dTypes$dCoupon.eqCoupon.eq)(x.coupons)(y.coupons) && Data$dDateTime.eqDateTime.eq(x.createdAt)(y.createdAt) && (() => {
    if (x.currency.tag === "PLN") { return y.currency.tag === "PLN"; }
    if (x.currency.tag === "GBP") { return y.currency.tag === "GBP"; }
    if (x.currency.tag === "USD") { return y.currency.tag === "USD"; }
    if (x.currency.tag === "EUR") { return y.currency.tag === "EUR"; }
    if (x.currency.tag === "RUB") { return y.currency.tag === "RUB"; }
    if (x.currency.tag === "RON") { return y.currency.tag === "RON"; }
    if (x.currency.tag === "CZK") { return y.currency.tag === "CZK"; }
    if (x.currency.tag === "HRK") { return y.currency.tag === "HRK"; }
    if (x.currency.tag === "BRL") { return y.currency.tag === "BRL"; }
    return false;
  })() && x.customerTotal === y.customerTotal && (() => {
    if (x.deliveryAddress.tag === "Nothing") { return y.deliveryAddress.tag === "Nothing"; }
    if (x.deliveryAddress.tag === "Just") {
      if (y.deliveryAddress.tag === "Just") { return Restaumatic$dGeocoding$dTypes$dDeliveryAddress.eqDeliveryAddress.eq(x.deliveryAddress._1)(y.deliveryAddress._1); }
      return false;
    }
    return false;
  })() && x.deliveryCost === y.deliveryCost && (() => {
    if (x.deliveryRating.tag === "Nothing") { return y.deliveryRating.tag === "Nothing"; }
    if (x.deliveryRating.tag === "Just") {
      if (y.deliveryRating.tag === "Just") { return x.deliveryRating._1 === y.deliveryRating._1; }
      return false;
    }
    return false;
  })() && Data$dEq.eqArrayImpl(eqDiscountInfo.eq)(x.discounts)(y.discounts) && (() => {
    if (x.fulfillmentMethodType.tag === "Delivery") { return y.fulfillmentMethodType.tag === "Delivery"; }
    if (x.fulfillmentMethodType.tag === "Takeaway") { return y.fulfillmentMethodType.tag === "Takeaway"; }
    if (x.fulfillmentMethodType.tag === "DineIn") { return y.fulfillmentMethodType.tag === "DineIn"; }
    if (x.fulfillmentMethodType.tag === "NoContactDelivery") { return y.fulfillmentMethodType.tag === "NoContactDelivery"; }
    return false;
  })() && x.id === y.id && Data$dEq.eqArrayImpl(eqItemInfo.eq)(x.items)(y.items) && x.onlinePayment === y.onlinePayment && (() => {
    if (x.origin.tag === "Nothing") { return y.origin.tag === "Nothing"; }
    if (x.origin.tag === "Just") {
      if (y.origin.tag === "Just") { return Restaumatic$dOrders$dTypes$dOrderOrigin.eqOrderOrigin.eq(x.origin._1)(y.origin._1); }
      return false;
    }
    return false;
  })() && (() => {
    if (x.requestedFulfillmentTime.tag === "Nothing") { return y.requestedFulfillmentTime.tag === "Nothing"; }
    if (x.requestedFulfillmentTime.tag === "Just") {
      if (y.requestedFulfillmentTime.tag === "Just") { return Data$dDateTime.eqDateTime.eq(x.requestedFulfillmentTime._1)(y.requestedFulfillmentTime._1); }
      return false;
    }
    return false;
  })() && (() => {
    if (x.restaurantRating.tag === "Nothing") { return y.restaurantRating.tag === "Nothing"; }
    if (x.restaurantRating.tag === "Just") {
      if (y.restaurantRating.tag === "Just") { return x.restaurantRating._1 === y.restaurantRating._1; }
      return false;
    }
    return false;
  })() && x.restaurantTotal === y.restaurantTotal && x.timezone === y.timezone && x.total === y.total && x.uuid === y.uuid
};
const genericOrderInfo = {to: x => x, from: x => x};
const genericItemInfo = {to: x => x, from: x => x};
const showItemInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["name", Data$dShow.showStringImpl(v.name)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "productId",
            (() => {
              if (v.productId.tag === "Just") { return "(Just " + v.productId._1 + ")"; }
              if (v.productId.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["promotion", v.promotion ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "quantity",
            Data$dShow.showIntImpl(v.quantity)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "rating",
            (() => {
              if (v.rating.tag === "Just") { return "(Just " + Data$dShow.showIntImpl(v.rating._1) + ")"; }
              if (v.rating.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["total", Data$dMoney$dRounded.toString(v.total)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "unitPrice",
            Data$dMoney$dRounded.toString(v.unitPrice)
          ]))([])))))));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ItemInfo"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeItemInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "name"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "productId"
    })(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({reflectSymbol: () => "promotion"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "quantity"
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({reflectSymbol: () => "rating"})(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "total"
    })(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({reflectSymbol: () => "unitPrice"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericDiscountInfo = {to: x => x, from: x => x};
const showDiscountInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["name", Data$dShow.showStringImpl(v.name)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "value",
            Data$dMoney$dRounded.toString(v.value)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "DiscountInfo"});
    return x => $0["genericShow'"](x);
  })()
};
const showOrderInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showItemInfo.show);
      const $1 = Data$dShow.showArrayImpl(showDiscountInfo.show);
      const $2 = Data$dShow.showArrayImpl(Restaumatic$dOrders$dTypes$dCoupon.showCoupon.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["coupons", $2(v.coupons)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "createdAt",
              DateUtils.formatISODateTime(v.createdAt)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["currency", Restaumatic$dCurrencies.showCurrency.show(v.currency)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "customerTotal",
              Data$dMoney$dRounded.toString(v.customerTotal)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "deliveryAddress",
              (() => {
                if (v.deliveryAddress.tag === "Just") { return "(Just " + Restaumatic$dGeocoding$dTypes$dDeliveryAddress.showDeliveryAddress.show(v.deliveryAddress._1) + ")"; }
                if (v.deliveryAddress.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["deliveryCost", Data$dMoney$dRounded.toString(v.deliveryCost)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "deliveryRating",
              (() => {
                if (v.deliveryRating.tag === "Just") { return "(Just " + Data$dShow.showIntImpl(v.deliveryRating._1) + ")"; }
                if (v.deliveryRating.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["discounts", $1(v.discounts)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "fulfillmentMethodType",
              Restaumatic$dOrders$dTypes$dFulfillmentMethodType.showFulfillmentMethodType.show(v.fulfillmentMethodType)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["id", Data$dShow.showIntImpl(v.id)]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["items", $0(v.items)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "onlinePayment",
              v.onlinePayment ? "true" : "false"
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "origin",
              (() => {
                if (v.origin.tag === "Just") { return "(Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")"; }
                if (v.origin.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "requestedFulfillmentTime",
              (() => {
                if (v.requestedFulfillmentTime.tag === "Just") { return "(Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")"; }
                if (v.requestedFulfillmentTime.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "restaurantRating",
              (() => {
                if (v.restaurantRating.tag === "Just") { return "(Just " + Data$dShow.showIntImpl(v.restaurantRating._1) + ")"; }
                if (v.restaurantRating.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["restaurantTotal", Data$dMoney$dRounded.toString(v.restaurantTotal)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "timezone",
              Data$dShow.showStringImpl(v.timezone)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["total", Data$dMoney$dRounded.toString(v.total)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "uuid",
              Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid)
            ]))([])))))))))))))))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "OrderInfo"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeDiscountInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "name"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "value"
    })(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeOrderInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "coupons"})({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dOrders$dTypes$dCoupon.unscrambleDecodeCoupon.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "createdAt"})(Data$dUTCTime.unscrambleDecodeUTCTime)(Unscramble.decodeRecordCons({reflectSymbol: () => "currency"})(Restaumatic$dCurrencies.unscrambleDecodeCurrency)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "customerTotal"
    })(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({reflectSymbol: () => "deliveryAddress"})(Unscramble.decodeMaybe(Restaumatic$dGeocoding$dTypes$dDeliveryAddress.unscrambleDecodeDeliveryAddress))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "deliveryCost"
    })(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({reflectSymbol: () => "deliveryRating"})(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "discounts"
    })({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeDiscountInfo.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "fulfillmentMethodType"})(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.unscrambleDecodeFulfillmentMethodType)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "id"
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({reflectSymbol: () => "items"})({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeItemInfo.unsafeDecode)})(Unscramble.decodeRecordCons({
      reflectSymbol: () => "onlinePayment"
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({reflectSymbol: () => "origin"})(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes$dOrderOrigin.unscrambleDecodeOrderOrigin))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "requestedFulfillmentTime"
    })(Unscramble.decodeMaybe(Data$dUTCTime.unscrambleDecodeUTCTime))(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantRating"})(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "restaurantTotal"
    })(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({reflectSymbol: () => "timezone"})(Data$dTime$dLocal.udecodeTZLabel)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "total"
    })(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({reflectSymbol: () => "uuid"})(Restaumatic$dOrders$dTypes$dOrderUUID.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordNil))))))))))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeItemInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericItemInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ItemInfo"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "unitPrice"
    })({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "total"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({
      reflectSymbol: () => "rating"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "quantity"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "promotion"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "productId"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "name"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeDiscountInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericDiscountInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "DiscountInfo"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "value"})({
      encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode
    }))({reflectSymbol: () => "name"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeOrderInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericOrderInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OrderInfo"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "uuid"
    })({encodeWithOptions: v => Restaumatic$dOrders$dTypes$dOrderUUID.encodeOrderUUID.encode}))({reflectSymbol: () => "total"})({
      encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode
    }))({reflectSymbol: () => "timezone"})({encodeWithOptions: v => Data$dTime$dLocal.encodeTZLabel.encode}))({reflectSymbol: () => "restaurantTotal"})({
      encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode
    }))({reflectSymbol: () => "restaurantRating"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "requestedFulfillmentTime"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return DateUtils.formatISODateTime(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "origin"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dTypes$dOrderOrigin.encodeOrderOrigin.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "onlinePayment"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "items"})((() => {
      const $0 = Data$dFunctor.arrayMap(encodeItemInfo.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "id"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "fulfillmentMethodType"})({
      encodeWithOptions: v => Restaumatic$dOrders$dTypes$dFulfillmentMethodType.encodeFulfillmentMethodType.encode
    }))({reflectSymbol: () => "discounts"})((() => {
      const $0 = Data$dFunctor.arrayMap(encodeDiscountInfo.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "deliveryRating"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "deliveryCost"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "deliveryAddress"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dGeocoding$dTypes$dDeliveryAddress.encodeDeliveryAddress.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "customerTotal"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "currency"})({
      encodeWithOptions: v => Restaumatic$dCurrencies.encodeCurrency.encode
    }))({reflectSymbol: () => "createdAt"})({encodeWithOptions: v => Data$dUTCTime.encodeUTCTime.encode}))({reflectSymbol: () => "coupons"})((() => {
      const $0 = Data$dFunctor.arrayMap(Restaumatic$dOrders$dTypes$dCoupon.encodeCoupon.encode);
      return {encodeWithOptions: v => $0};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeItemInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericItemInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "ItemInfo"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "unitPrice"
  })({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "total"})({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({
    reflectSymbol: () => "rating"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readInt(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "quantity"})({
    decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "promotion"})({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "productId"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)
  })())({reflectSymbol: () => "name"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeDiscountInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericDiscountInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "DiscountInfo"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "value"
  })({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "name"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeOrderInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericOrderInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "OrderInfo"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "uuid"
  })({decodeWithOptions: v => Restaumatic$dOrders$dTypes$dOrderUUID.decodeOrderUUID.decode})())({reflectSymbol: () => "total"})({
    decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode
  })())({reflectSymbol: () => "timezone"})({decodeWithOptions: v => Data$dTime$dLocal.decodeTZLabel.decode})())({reflectSymbol: () => "restaurantTotal"})({
    decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode
  })())({reflectSymbol: () => "restaurantRating"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readInt(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "requestedFulfillmentTime"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUTCTime.decodeUTCTime.decode)})())({reflectSymbol: () => "origin"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes$dOrderOrigin.decodeOrderOrigin.decode)
  })())({reflectSymbol: () => "onlinePayment"})({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "items"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeItemInfo);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "id"})({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "fulfillmentMethodType"})({
    decodeWithOptions: v => Restaumatic$dOrders$dTypes$dFulfillmentMethodType.decodeFulfillmentMethodType.decode
  })())({reflectSymbol: () => "discounts"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeDiscountInfo);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "deliveryRating"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readInt(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "deliveryCost"
  })({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "deliveryAddress"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dGeocoding$dTypes$dDeliveryAddress.decodeDeliveryAddress.decode)
  })())({reflectSymbol: () => "customerTotal"})({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "currency"})({
    decodeWithOptions: v => Restaumatic$dCurrencies.decodeCurrency.decode
  })())({reflectSymbol: () => "createdAt"})({decodeWithOptions: v => Data$dUTCTime.decodeUTCTime.decode})())({reflectSymbol: () => "coupons"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dOrders$dTypes$dCoupon.decodeCoupon);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  DiscountInfo,
  ItemInfo,
  OrderInfo,
  decodeDiscountInfo,
  decodeItemInfo,
  decodeOrderInfo,
  encodeDiscountInfo,
  encodeItemInfo,
  encodeOrderInfo,
  eqDiscountInfo,
  eqItemInfo,
  eqOrderInfo,
  genericDiscountInfo,
  genericItemInfo,
  genericOrderInfo,
  hasFieldDiscountInfo,
  hasFieldItemInfo,
  hasFieldOrderInfo,
  newtypeDiscountInfo_,
  newtypeItemInfo_,
  newtypeOrderInfo_,
  showDiscountInfo,
  showItemInfo,
  showOrderInfo,
  unscrambleDecodeDiscountInfo,
  unscrambleDecodeItemInfo,
  unscrambleDecodeOrderInfo
};
